import { render } from "./notification_container.vue?vue&type=template&id=a947ff12&scoped=true&ts=true"
import script from "./notification_container.vue?vue&type=script&lang=ts"
export * from "./notification_container.vue?vue&type=script&lang=ts"

import "./notification_container.vue?vue&type=style&index=0&id=a947ff12&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a947ff12"]])

export default __exports__